import { useState, useEffect } from "react";
import ImageModal from "../ImageModal";
import Link from "next/link";
import { getDomainFromUrl } from "../../tools/helper";
import { MdPlayArrow } from "react-icons/md";

export default function ItemCommentairesMedia({ ...props }) {
  const [playGif, setPlayGif] = useState(false);

  if (
    props.com.url_media &&
    props.com.id_media &&
    props.com.url_media.match(/giphy/)
  ) {
    var urlGif =
      "https://media3.giphy.com/media/" + props.com.id_media + "/200h.gif";
    var urlGifStatic =
      "https://media3.giphy.com/media/" + props.com.id_media + "/200h.jpg";
    var urlGifStatic =
      "https://media3.giphy.com/media/" + props.com.id_media + "/200h_s.gif";
    var urlGifWebp =
      "https://media3.giphy.com/media/" + props.com.id_media + "/200h.webp";
  }
  // else if tenor
  else if (
    props.com.url_media &&
    props.com.id_media &&
    props.com.url_media.match(/tenor/)
  ) {
    var urlGif =
      "https://media.tenor.com/images/" + props.com.id_media + "/tenor.gif";
    var urlGifStatic = props.com.miniature_raw;
    var urlGifWebp = props.com.url_media;
  }

  // liens youtube
  const [youTubeLink, setYouTubeLink] = useState("");
  const [playYouTube, setPlayYouTube] = useState(false);
  const [playYoutubeId, setPlayYoutubeId] = useState(0);
  useEffect(() => {
    extractYouTubeLink(props.com.texte);
  }, [props.com.texte]); // The effect runs once the component is mounted and whenever 'text' changes.

  const extractYouTubeLink = (inputText) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const youtubeRegex =
      /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/;

    const urls = inputText.match(urlRegex);

    if (!urls) return; // If no URLs are found, do nothing.

    const youTubeUrls = urls.filter((url) => youtubeRegex.test(url));

    if (youTubeUrls.length > 0) {
      const lastYouTubeUrl = youTubeUrls[youTubeUrls.length - 1];
      const videoId = extractVideoID(lastYouTubeUrl);

      if (videoId) {
        const embedUrl = `https://www.youtube.com/embed/${videoId}`;
        setYouTubeLink(embedUrl); // Set the YouTube link in the state to render it in iframe
        setPlayYoutubeId(videoId);
      }
    }
  };

  const extractVideoID = (url) => {
    const shortForm = /https:\/\/youtu.be\/([a-zA-Z0-9_-]{11})/;
    const longForm = /https:\/\/www.youtube.com\/watch\?v=([a-zA-Z0-9_-]{11})/;

    const match = url.match(shortForm) || url.match(longForm);
    return match ? match[1] : null; // Return the ID if matched, otherwise null
  };

  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://tenor.com/embed.js";
  //   script.async = true;
  //   document.body.appendChild(script);

  //   return () => {
  //     document.body.removeChild(script); // Cleanup the script on component unmount
  //   };
  // }, []);

  // const displayTenor = (id) => {
  //   const key = process.env.NEXT_PUBLIC_TENOR_ID;
  //   const tenorUrl = `https://tenor.googleapis.com/v2/posts?key=${key}&media_filter=webp,gif&ids=${id}`;
  //   const [data, setData] = useState(null);

  //   axios
  //     .get(tenorUrl)
  //     .then((response) => {
  //       if (response.data) {
  //         setData(response.data.results[0]);
  //       } else {
  //         console.log("No data returned");
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });

  //   if (!data) {
  //     return <div>Loading...</div>;
  //   }

  //   return (
  //     <picture className="z-10 max-w-full">
  //       <source type="image/webp" srcSet={data.media_formats.webp.url} />
  //       <img
  //         className="max-w-full sm:max-h-64"
  //         src={data.media_formats.gif.url}
  //         alt={"GIF"}
  //         preload="none"
  //       />
  //     </picture>
  //   );
  // };

  return (
    <div className={`${props.com.texte ? "mt-2" : ""}`}>
      {/* image */}
      {props.com.image ? (
        <>
          <Link
            href={"/img?src=" + props.com.image}
            className="relative inline-block"
          >
            {props.com.nsfw == 1 && (
              <div
                className={`absolute z-10 w-full h-full flex items-center justify-center bg-base-200`}
              >
                <div className="text-base-content/50 font-semibold">NSFW</div>
              </div>
            )}
            {/* {props.com.image.match(/.mp4/) ? (
              <video
                className="max-w-xs"
                src={props.com.image}
                autoPlay
                muted
                loop
              />
            ) : (
              <img src={props.com.image} alt={"IMG"} className="max-w-xs" />
            )} */}
            <img
              src={props.com.image}
              alt={"IMG"}
              className="max-w-full sm:max-w-xs"
            />
          </Link>
        </>
      ) : null}

      {/* tenor */}
      {props.com.url_media &&
      props.com.url_media.match(/tenor/) &&
      props.com.url_media_id ? (
        <div
          className={`${
            props.com.tenor.results[0].media_formats.gif.dims[0] ===
            props.com.tenor.results[0].media_formats.gif.dims[1]
              ? "sm:max-w-xs"
              : props.com.tenor.results[0].media_formats.gif.dims[0] >
                props.com.tenor.results[0].media_formats.gif.dims[1]
              ? "sm:max-w-xs" // horizontal
              : "sm:max-w-xs" // vertical
          } relative inline-block`}
        >
          <picture className="z-10">
            <source
              type="image/webp"
              srcSet={props.com.tenor.results[0].media_formats.webp.url}
            />
            <img
              src={props.com.tenor.results[0].media_formats.gif.url}
              alt={props.com.tenor.results[0].content_description || "GIF"}
              width={props.com.tenor.results[0].media_formats.gif.dims[0]}
              height={props.com.tenor.results[0].media_formats.gif.dims[1]}
            />
          </picture>
          <img
            src="https://www.gstatic.com/tenor/web/attribution/via_tenor_logo_white.png"
            className="h-2 absolute right-0 bottom-0 z-10 m-2"
          />
        </div>
      ) : null}
      {/* giphy */}
      {props.com.url_media &&
      urlGifWebp &&
      props.com.url_media.match(/giphy/) ? (
        <div
          onClick={() => setPlayGif(!playGif)}
          className={`relative inline-block bg-base-200 ${
            !playGif && "cursor-pointer"
          }
            `}
        >
          {props.com.nsfw == 1 && !playGif ? (
            <div
              className={`absolute z-10 w-full h-full flex items-center justify-center bg-base-200`}
            >
              <div className="text-base-content/50 font-semibold">NSFW</div>
            </div>
          ) : null}
          {playGif ? (
            <>
              <picture className="z-10 absolute">
                <source type="image/webp" srcSet={urlGifWebp} />
                <img
                  className="max-w-full"
                  src={urlGif}
                  alt={"GIF"}
                  preload="none"
                />
              </picture>
              <img
                className="max-w-full"
                src={urlGifStatic}
                alt={"GIF"}
                preload="none"
              />
              {/* <div className="z-20">
                <iframe
                  src={`https://giphy.com/embed/${props.com.id_media}`}
                  width="480"
                  height="271"
                  className="max-w-full"
                  allowFullScreen
                />
              </div> */}
            </>
          ) : (
            <>
              <div className="absolute z-10 flex items-center w-full h-full justify-center">
                <div className="text-white font-bold border-white bg-black/70 border-2 rounded-full h-8 w-8 flex items-center justify-center text-xs">
                  GIF
                </div>
              </div>
              <img
                className="max-w-full"
                src={urlGifStatic}
                alt={"GIF"}
                preload="none"
              />
            </>
          )}
        </div>
      ) : props.com.url_media && !urlGifWebp ? (
        <div className="mt-2">
          <Link
            href={props.com.url_media}
            rel="nofollow"
            target="_blank"
            className="text-xs text-primary"
          >
            {props.com.url_media}
          </Link>
        </div>
      ) : youTubeLink && !props.com.image && !props.com.url_media ? (
        <div className="relative block pb-9/12 sm:pb-3/12 sm:max-w-sm bg-base-200">
          {!playYouTube ? (
            <div
              onClick={(e) => setPlayYouTube(true)}
              className="cursor-pointer"
            >
              <div className="absolute z-1 h-full w-full flex justify-center items-center text-white">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-black/50">
                  <MdPlayArrow className="w-8 h-8 rounded-full" />
                </div>
              </div>
              <div className="absolute z-1 bottom-2 left-2 bg-black text-white text-xxs px-1 rounded">
                {getDomainFromUrl(props.com.url_media)}
              </div>
              <img
                src={
                  "https://i.ytimg.com/vi/" + playYoutubeId + "/hqdefault.jpg"
                }
                alt="youtube"
                className="absolute w-full h-full object-contain"
              />
            </div>
          ) : (
            <iframe
              src={youTubeLink}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute w-full h-full object-contain"
            />
          )}
        </div>
      ) : null}
    </div>
  );
}
